import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import ScrollReveal from "@/components/base/ScrollReveal";
import { GROUP_COMPANIES, type GroupCompany } from "@/constants/site";

function CardBody({ company }: { company: GroupCompany }) {
  return (
    <>
      <div className="h-52 w-full overflow-hidden bg-background-200 md:h-56">
        <img
          src={company.image}
          alt={`${company.name} イメージ`}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="flex flex-wrap items-center gap-3">
          <span className="border border-background-300 px-2.5 py-1 font-body text-[11px] tracking-[0.1em] text-foreground-700">
            {company.field}
          </span>
          <span className="font-label text-[11px] tracking-[0.26em] text-secondary-500">
            {company.en}
          </span>
        </div>
        <h3 className="mt-4 font-heading text-lg font-medium tracking-[0.04em] text-foreground-950">
          {company.name}
        </h3>
        {company.tagline ? (
          <p className="mt-2 font-heading text-[15px] tracking-[0.04em] text-accent-700">
            {company.tagline}
          </p>
        ) : null}
        <p className="mt-3 flex-1 font-body text-sm leading-[1.9] text-foreground-700">
          {company.desc}
        </p>
        {company.url ? (
          <span className="mt-6 inline-flex items-center gap-2 font-label text-xs tracking-[0.24em] text-foreground-950 transition-colors group-hover:text-accent-700">
            VISIT SITE
            <i className="ri-arrow-right-up-line" />
          </span>
        ) : (
          <span className="mt-6 font-label text-xs tracking-[0.24em] text-secondary-500">
            WEBSITE COMING SOON
          </span>
        )}
      </div>
    </>
  );
}

export default function GroupPreview() {
  const cardClass =
    "group flex h-full flex-col overflow-hidden border border-background-200 bg-background-50 shadow-sm transition-shadow duration-300";

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
        <ScrollReveal>
          <div>
            <SectionHeading label="グループ企業" en="GROUP" />
            <p className="mt-8 max-w-2xl font-body text-[15px] leading-[2] text-foreground-700">
              住まい・通信・食。暮らしに身近な領域で、グループ各社が
              それぞれの強みを活かしてお客様に価値を届けています。
            </p>
          </div>
        </ScrollReveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 md:gap-8">
          {GROUP_COMPANIES.map((company, index) => (
            <ScrollReveal key={company.name} delay={index * 120}>
              {company.url ? (
                <a
                  href={company.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${cardClass} hover:shadow-lg`}
                >
                  <CardBody company={company} />
                </a>
              ) : (
                <div className={cardClass}>
                  <CardBody company={company} />
                </div>
              )}
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={200}>
          <div className="mt-14 flex justify-center">
            <Link
              to="/group"
              className="inline-flex items-center gap-3 whitespace-nowrap border border-foreground-950 px-9 py-3.5 font-body text-[12px] tracking-[0.22em] text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
            >
              VIEW GROUP
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
